<template>
    <div class="header-privacy-policy" :class="display">
    <div class="container">
        <div class="cookies-message">
            <button href="/" class="close-cooki-message float-right" @click="privacyAccepted"><i aria-hidden="true" class="fa fa-times-circle"></i></button>
            <div v-html="content"></div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    props:{
        content : String
    },
    data: function(){
        return {
            display:'unactive',
            cookie_name: 'cookie_policy_accepted',
            expiry_days: 7,
        }
    },
    methods:{
        privacyAccepted() {
            this.setCookie(this.cookie_name,true,this.expiry_days);
            this.display = 'unactive';
        },
        setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    },
    mounted:function(){
        let accepted = this.getCookie(this.cookie_name);
        if(!accepted){
            this.display = '';
        }
    }
}
</script>